export default __webpack_public_path__ + "static/media/loading.3910906e.gif";